/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import HospitalBillDiscount from './hospital-bill-discount';
import HospitalBillDiscountDetail from './hospital-bill-discount-detail';
import HospitalBillDiscountUpdate from './hospital-bill-discount-update';
import HospitalBillDiscountDeleteDialog from './hospital-bill-discount-delete-dialog';

const HospitalBillDiscountRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<HospitalBillDiscount />} />
    <Route path="new" element={<HospitalBillDiscountUpdate />} />
    <Route path=":id">
      <Route index element={<HospitalBillDiscountDetail />} />
      <Route path="edit" element={<HospitalBillDiscountUpdate />} />
      <Route path="delete" element={<HospitalBillDiscountDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default HospitalBillDiscountRoutes;
